const RecoversPossessionSetting = Object.freeze({
    Unset: "UNSET",
    Yes: "YES",
    No: "NO"
});

export default RecoversPossessionSetting;
